import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { /*useDispatch,*/ useSelector } from "react-redux";
// import { hideLoadingScreen } from "../../store/slices/loading";
import { Stack, Typography } from "@mui/material";

const LoadingScreen = () => {
  //   const [open, setOpen] = React.useState(false);
  //   const handleClose = () => {
  //     setOpen(false);
  //   };
  //   const handleOpen = () => {
  //     setOpen(true);
  //   };
  const isOpen = useSelector((state) => state.loading.isOpen);
//   const dispatch = useDispatch();

  return (
    <Backdrop
    //   onClick={() => {
    //     dispatch(hideLoadingScreen());
    //   }}
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isOpen}
    >
	<Stack flexDirection="column" alignItems="center" justifyContent="center">
      <CircularProgress color="inherit" />
      <Typography variant="h5" component="span">Cargando...</Typography>

	</Stack>
    </Backdrop>
  );
};
export default LoadingScreen;
